import { getLegacyBridge } from "./state";
import { LOCALE_CHANGE_EVENT } from "./i18n";
import {
  applyAuthSourceSelection,
  authSourceDetailText,
  currentAuthSource,
  handleAuthSourceClick,
  isDirectApiMode,
  refreshHealth,
  renderAuthSource,
  setAuthSource,
  sourceLabel,
} from "./auth-source";
import {
  setModeSettingsVariant,
  setModeSpecificElementVisibility,
  updateModeSpecificSettings,
} from "./api-mode-settings";
import {
  activeApiProvider,
  addApiProvider,
  addGatewayProvider,
  apiModeLabel,
  backendForAuthSource,
  closeApiSettingsModal,
  codexModeLabel,
  currentApiImageModel,
  currentApiImagesConcurrency,
  currentApiMode,
  currentApiProviderId,
  currentApiProviderLabel,
  currentCodexMode,
  confirmDeleteApiProvider,
  copyApiProvider,
  deleteApiProvider,
  editApiProvider,
  mergeApiProviderKeys,
  normalizeApiImagesConcurrency,
  normalizeApiProvider,
  normalizeApiSettings,
  openApiSettingsModal,
  persistApiSettings,
  populateApiSettingsForm,
  readApiSettingsForm,
  refreshApiSettings,
  restoreApiSettings,
  cancelApiProviderEdit,
  saveApiSettings,
  saveApiProviderEdit,
  selectApiProvider,
  setApiSettingsFeedback,
  taskApiProviderId,
  taskApiProviderLabel,
  taskBackendLabel,
  taskBackendValue,
  moveApiProvider,
  toggleApiProviderSortMode,
} from "./api-provider-settings";

let apiSettingsFeatureInitialized = false;

export function initApiSettingsFeature(): void {
  if (apiSettingsFeatureInitialized) return;
  apiSettingsFeatureInitialized = true;
  document.addEventListener(LOCALE_CHANGE_EVENT, () => {
    const bridge = getLegacyBridge();
    renderAuthSource(bridge.state.authStatus);
    const apiPanelOpen = Boolean(bridge.els.systemSettingsApiPanel && !bridge.els.systemSettingsApiPanel.hidden);
    const codexPanelOpen = Boolean(bridge.els.systemSettingsCodexPanel && !bridge.els.systemSettingsCodexPanel.hidden);
    if (!bridge.els.systemSettingsModal?.classList.contains("hidden") && (apiPanelOpen || codexPanelOpen)) {
      setApiSettingsFeedback("", "");
    }
  });
  Object.assign(getLegacyBridge().methods, {
    refreshHealth,
    setAuthSource,
    handleAuthSourceClick,
    renderAuthSource,
    applyAuthSourceSelection,
    authSourceDetailText,
    sourceLabel,
    currentAuthSource,
    isDirectApiMode,
    setModeSpecificElementVisibility,
    setModeSettingsVariant,
    updateModeSpecificSettings,
    normalizeApiProvider,
    normalizeApiImagesConcurrency,
    normalizeApiSettings,
    activeApiProvider,
    restoreApiSettings,
    persistApiSettings,
    mergeApiProviderKeys,
    refreshApiSettings,
    populateApiSettingsForm,
    readApiSettingsForm,
    currentApiProviderId,
    currentApiProviderLabel,
    addApiProvider,
    addGatewayProvider,
    confirmDeleteApiProvider,
    copyApiProvider,
    deleteApiProvider,
    editApiProvider,
    cancelApiProviderEdit,
    saveApiProviderEdit,
    selectApiProvider,
    moveApiProvider,
    toggleApiProviderSortMode,
    openApiSettingsModal,
    closeApiSettingsModal,
    currentApiImageModel,
    currentApiMode,
    currentCodexMode,
    currentApiImagesConcurrency,
    apiModeLabel,
    codexModeLabel,
    backendForAuthSource,
    taskBackendValue,
    taskApiProviderId,
    taskApiProviderLabel,
    taskBackendLabel,
    setApiSettingsFeedback,
    saveApiSettings,
  });
}
